jQuery(function($) {
  let $content_embeds = $('#content iframe[src*="youtube.com"]');
  if ($content_embeds.length !== 0) {
    $content_embeds.parent().addClass('vid-wrap vid-wrap-static');
  }
});
